module.exports = __webpack_public_path__ + "img/biandian.24f12032.png";